import {DataSource} from '@angular/cdk/collections';
import {Component, OnDestroy, OnInit, Optional} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {Subscription} from 'rxjs';
import {DataSourceFacade} from '../../../data-source/facade/data-source.facade';
import {ToastrWrapperService} from '../../services/toastr-wrapper.service';

@Component({
  selector: 'morva-stop-schedule-dialog',
  templateUrl: './stop-schedule-dialog.component.html',
  styleUrls: ['./stop-schedule-dialog.component.scss'],
})
export class StopScheduleDialogComponent implements OnInit {

  mode: 'schedule' | 'manual' = 'schedule'
  scheduleTitle: string;

  submitting = false;

  constructor(
    private dialogRef: NbDialogRef<any>,
  ) {
  }

  ngOnInit(): void {
  }

  closeDialog(isAccept) {
    this.dialogRef.close(isAccept);
  }

}
